module.exports = __webpack_public_path__ + "img/lab.11af14d7.jpg";